var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "form-group" },
    [
      _c("label", [_vm._v("Missä?")]),
      _vm._v(" "),
      _c(
        "multiselect",
        {
          attrs: {
            options: _vm.cityOptions,
            searchable: true,
            "track-by": "id",
            label: "name",
            "options-limit": 400,
            "allow-empty": false,
            placeholder: "Valitse kunta",
            selectLabel: "",
            deselectLabel: "",
            selectedLabel: "",
            "show-no-results": false,
            "hide-selected": false,
            value: _vm.selectedCity,
          },
          on: { select: _vm.onSelect },
        },
        [_c("span", { attrs: { slot: "noResult" }, slot: "noResult" })]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }